import { Duration } from './settings'
import { applyEntitySchema, sourceJson } from '../../_utils/fcdc-v2'
import { gracePeriodSchema } from '../schema/pricing.schema'

export class GracePeriod {
  duration: Duration
  maxUnlocks?: number
  usedUnlocks: number

  constructor(json: any) {
    const source = sourceJson(json) as any
    this.duration = source.duration
    this.maxUnlocks = source.maxUnlocks
    this.usedUnlocks = source.usedUnlocks
    applyEntitySchema(this, gracePeriodSchema, source, {})
  }
}
